import { createAsyncThunk } from '@reduxjs/toolkit'

export const addStep = createAsyncThunk('calc/addstep', async (item, { rejectWithValue }) => {
  const steps = localStorage.getItem('steps') ? JSON.parse(localStorage.getItem('steps')) : []
  steps.push(item)
  try {
    localStorage.setItem('steps', JSON.stringify(steps))
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const changeStep = createAsyncThunk('calc/changestep', async (item, { rejectWithValue }) => {
  let steps = localStorage.getItem('steps') ? JSON.parse(localStorage.getItem('steps')) : []
  steps[item.index] = item.step
  steps.splice(item.index + 1) // очистка последующих шагов
  try {
    localStorage.setItem('steps', JSON.stringify(steps))
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const removeStep = createAsyncThunk(
  'calc/removestep',
  async (index, { rejectWithValue }) => {
    const steps = JSON.parse(localStorage.getItem('steps'))
    steps.splice(index, 1)
    try {
      localStorage.setItem('steps', JSON.stringify(steps))
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const clearSteps = createAsyncThunk('calc/clearsteps', async (...args) => {
  try {
    localStorage.setItem('steps', JSON.stringify([]))
  } catch (error) {
    const { rejectWithValue } = args[1]
    return rejectWithValue(error)
  }
})

export const getSteps = createAsyncThunk('calc/getsteps', async (...args) => {
  try {
    const data = JSON.parse(localStorage.getItem('steps'))
    if (!data) return []
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    // return custom error message from API if any

    return rejectWithValue(error)
  }
})

export const setCurrentStep = createAsyncThunk('calc/setcurrentstep', async (step) => {
  return step
})
